var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuTracing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    color: "#1D2229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.089 12L11.9895 21.6385",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6145 16.4374V7.5626C20.6145 7.42978 20.5792 7.29935 20.5123 7.18463C20.4454 7.06991 20.3492 6.97503 20.2335 6.90968L12.3585 2.45859C12.246 2.39495 12.1188 2.36151 11.9895 2.36151C11.8602 2.36151 11.733 2.39495 11.6205 2.45859L3.74546 6.90968C3.62983 6.97503 3.53364 7.06991 3.4667 7.18463C3.39977 7.29935 3.3645 7.42978 3.3645 7.5626V16.4374C3.3645 16.5702 3.39977 16.7007 3.4667 16.8154C3.53364 16.9301 3.62983 17.025 3.74546 17.0903L11.6205 21.5414C11.733 21.605 11.8602 21.6385 11.9895 21.6385C12.1188 21.6385 12.246 21.605 12.3585 21.5414L20.2335 17.0903C20.3492 17.025 20.4454 16.9301 20.5123 16.8154C20.5792 16.7007 20.6145 16.5702 20.6145 16.4374V16.4374Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5117 7.18377L12.0889 12L3.46777 7.18274",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5959 13.9229V9.4229L7.89783 4.56271",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTracing);
export default __webpack_public_path__ + "static/media/menu-tracing.b14d759f.svg";
export { ForwardRef as ReactComponent };